import backIconMask from '../../../assets/react-navigation/elements/back-icon-mask.png';
import backIcon from '../../../assets/react-navigation/elements/back-icon.png';
import clearIcon from '../../../assets/react-navigation/elements/clear-icon.png';
import closeIcon from '../../../assets/react-navigation/elements/close-icon.png';
import searchIcon from '../../../assets/react-navigation/elements/search-icon.png';

/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Background } from './Background';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Badge } from './Badge';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Button } from './Button';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { getDefaultSidebarWidth } from './getDefaultSidebarWidth';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { getDefaultHeaderHeight } from './Header/getDefaultHeaderHeight';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { getHeaderTitle } from './Header/getHeaderTitle';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Header } from './Header/Header';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderBackButton } from './Header/HeaderBackButton';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderBackContext } from './Header/HeaderBackContext';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderBackground } from './Header/HeaderBackground';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderButton } from './Header/HeaderButton';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderHeightContext } from './Header/HeaderHeightContext';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderShownContext } from './Header/HeaderShownContext';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { HeaderTitle } from './Header/HeaderTitle';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { useHeaderHeight } from './Header/useHeaderHeight';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { getLabel } from './Label/getLabel';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Label } from './Label/Label';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Lazy } from './Lazy';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { MissingIcon } from './MissingIcon';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { PlatformPressable } from './PlatformPressable';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { ResourceSavingView } from './ResourceSavingView';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { SafeAreaProviderCompat } from './SafeAreaProviderCompat';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Screen } from './Screen';
/**
 * @deprecated Copy the component into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { Text } from './Text';
/**
 * @deprecated Copy the helper into your codebase to keep using it. Will be
 * removed in a future SDK.
 */
export { useFrameSize } from './useFrameSize';

/**
 * @deprecated Will be removed in a future SDK.
 */
export const Assets = [backIcon, backIconMask, searchIcon, closeIcon, clearIcon];

export * from './types';
